import { Mail } from 'lucide-react';

export function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-12">
          <div className="grid gap-8 lg:grid-cols-3">
            {/* Brand */}
            <div>
              <div className="mb-4 flex items-center gap-2">
                <img src="/logo.svg" alt="SafeIdea.ai" className="h-8 w-8" />
                <span className="text-xl font-bold text-gray-900">SafeIdea.ai</span>
              </div>
              <p className="text-sm text-gray-600">
                AI-powered platform for IP professionals. Seven specialized workflows, unlimited
                local AI, and patent-pending deidentification technology.
              </p>
            </div>

            {/* Contact */}
            <div>
              <h3 className="mb-4 text-sm font-semibold text-gray-900">Contact</h3>
              <div className="space-y-2">
                <a
                  href="mailto:info@safeidea.ai"
                  className="flex items-center gap-2 text-sm text-gray-600 hover:text-blue-600"
                >
                  <Mail className="h-4 w-4" />
                  info@safeidea.ai
                </a>
              </div>
            </div>

            {/* Legal */}
            <div>
              <h3 className="mb-4 text-sm font-semibold text-gray-900">Company</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>SafeIdea.AI LLC</li>
                <li>Patent-Pending Technology</li>
                <li>Currently in Beta</li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-12 border-t border-gray-200 pt-8">
            <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
              <p
                className="text-sm text-gray-600 cursor-help"
                title={`Version: ${import.meta.env.VITE_APP_VERSION || 'dev'}${
                  import.meta.env.VITE_BUILD_TYPE ? ` (${import.meta.env.VITE_BUILD_TYPE})` : ''
                }${
                  import.meta.env.VITE_BUILD_DATE || new Date().toISOString()
                    ? `\nBuilt: ${new Date(import.meta.env.VITE_BUILD_DATE || new Date().toISOString()).toLocaleString()}`
                    : ''
                }${
                  import.meta.env.VITE_BUILD_COMMIT ||
                  `dev-${Math.random().toString(36).substring(2, 9)}`
                    ? `\nCommit: ${(import.meta.env.VITE_BUILD_COMMIT || `dev-${Math.random().toString(36).substring(2, 9)}`).slice(0, 7)}`
                    : ''
                }`}
              >
                © {new Date().getFullYear()} SafeIdea LLC. All rights reserved.
              </p>
              <p className="text-sm text-gray-600">
                Built for IP professionals across all industries
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
